const DEV_ASSETS_PATH = "https://cdn.dev.envs.lookiero.tech";
export { DEV_ASSETS_PATH };
